const mutations = {
  validar(state, { cedula, fecha, debeActualizar }) {
    // console.log(fecha);
    // console.log(debeActualizar);
    state.valida = true;
    state.cedula = cedula;
    state.fecha_nacimiento = fecha;
    state.debeActualizar = debeActualizar;
  },
  setEstrategias(state, estrategias) {
    state.estrategias = estrategias;
  },
  salir(state) {
    state.valida = false;
    state.cedula = "";
  },
  setDatosCPE(state, datos) {
    state.datos_cpe = datos;
  },
  setDatosMEN(state, datos) {
    state.datos_men = datos;
  },
  setEstrategia(state, estrategia) {
    state.estrategia = estrategia;
  },
  setCargandoRuta(state, val) {
    state.cargandoRuta = val;
  }
};

export default mutations;
